import Login from "../src/views/Auth/Login";
import TrocarSenha from "../src/views/Auth/TrocarSenha";
import Dashboard from "../src/views/Home/Dashboard";
import FormularioLista from "../src/views/Cadastros/Formularios/FormularioLista";
import RegionalFicha from "../src/views/Cadastros/Regionais/RegionalFicha";
import EsqueceuSenha from "../src/views/Auth/EsqueceuSenha";
import ConcessionariaLista from "../src/views/Cadastros/Concessionarias/ConcessionariaLista";
import IndiceIQGLista from "../src/views/Cadastros/IndicesIQG/IndiceIQGLista";
import PenalidadeLista from "../src/views/Cadastros/Penalidades/PenalidadeLista";
import PrazoResponsividadeFicha from "../src/views/Cadastros/PrazoResponsividade/PrazoResponsividadeFicha";
import DiasNaoUteisLista from "../src/views/Cadastros/DiasNaoUteis/DiasNaoUteisLista";
import UsuarioLista from "../src/views/Seguranca/UsuarioLista";
import ConsultaVistoriaLista from "../src/views/ConsultaVistoria/ConsultaVistoriaLista";
import VistoriaOnline from "../src/views/Vistoria/VistoriaOnline";
import VistoriaFichaImpressao from "../src/views/Shared/VistoriaFichaImpressao";
import ConsultaIQG from "views/IQG/ConsultaIQG";
import Contratos from "../src/views/Cadastros/Contratos/Contratos";
import DocumentoLista from "../src/views/Cadastros/Documentos/DocumentoLista";
import AditivosReajustes from "views/AditivosReajustes/AditivosReajustes";
import CategoriaFiscalizacaoLista from "../src/views/Cadastros/Categorias/CategoriaFiscalizacaoLista";
import PainelFiscalizacao from "../src/views/Painel/PainelFiscalizacao";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "fas fa-chart-line",
    component: Login,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/esqueceusenha",
    name: "Esqueceu Senha",
    icon: "",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "TrocarSenha",
    icon: "",
    component: TrocarSenha,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/inicio",
    name: "Inicio",
    icon: "fas fa-home",
    component: Dashboard,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "PainelSituacaoContrato",
    path: "/painelfiscalizacao",
    name: "Situação por Contrato",
    icon: "fas fa-chart-pie",
    component: PainelFiscalizacao,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "ConsultaVistoria",
    path: "/consultavistoria",
    name: "Consulta Vistoria",
    icon: "fas fa-folder-open",
    component: ConsultaVistoriaLista,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "VistoriaOnline",
    path: "/vistoriaonline",
    name: "Vistoria Online",
    icon: "fas fa-file-signature",
    component: VistoriaOnline,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "RelatorioIQG",
    path: "/relatorioIQG",
    name: "Relatório de IQG",
    icon: "fas fa-chart-bar",
    component: ConsultaIQG,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/impressaovistoria",
    name: "Impressão Vistoria",
    icon: "fas fa-file-signature",
    component: VistoriaFichaImpressao,
    layout: "/empty",
    sidebar: false
  },
  {
    name: "Cadastros",
    icon: "fas fa-cogs",
    layout: "/admin",
    sidebar: true,
    submenus: [
      {
        codigoFuncionalidade: "Documentos",
        path: "/documentos",
        name: "Documentos",
        icon: "fas fa-file",
        component: DocumentoLista,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroRegional",
        path: "/regionais",
        name: "Regionais",
        icon: "fas fa-globe-americas",
        component: RegionalFicha,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroConcessionaria",
        path: "/concessionarias",
        name: "Concessionárias",
        icon: "fas fa-building",
        component: ConcessionariaLista,
        sidebar: true
      },
      {
        codigoFuncionalidade: "Contratos",
        path: "/contratos",
        name: "Contratos",
        icon: "fas fa-file-alt",
        component: Contratos,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroIndiceIQG",
        path: "/iqg",
        name: "Índices IQG",
        icon: "fas fa-calculator",
        component: IndiceIQGLista,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroFormularios",
        path: "/formularios",
        name: "Formulários",
        icon: "fas fa-file-contract",
        component: FormularioLista,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "CadastroCategorias",
        path: "/categorias",
        name: "Categorias de Fiscalização",
        icon: "fas fa-tags",
        component: CategoriaFiscalizacaoLista,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroPenalidade",
        path: "/penalidades",
        name: "Penalidades",
        icon: "fas fa-exclamation-circle",
        component: PenalidadeLista,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroPrazoResponsividade",
        path: "/prazoresponsividade",
        name: "Prazos de Responsividade",
        icon: "fas fa-hourglass-half",
        component: PrazoResponsividadeFicha,
        sidebar: true
      },
      {
        codigoFuncionalidade: "CadastroDiasNaoUteis",
        path: "/diasnaouteis",
        name: "Dias Não Úteis",
        icon: "fas fa-calendar-times",
        component: DiasNaoUteisLista,
        sidebar: true
      },
    ]
  },
  {
    codigoFuncionalidade: "Aditivos",
    path: "/aditivos",
    name: "Aditivos e Reajustes",
    icon: "fas fa-folder-plus",
    component: AditivosReajustes,
    layout: "/admin",
    sidebar: true
  },
  {
    codigoFuncionalidade: "Usuarios",
    path: "/cadastrousuarios",
    name: "Usuários",
    icon: "fas fa-users",
    component: UsuarioLista,
    layout: "/admin",
    sidebar: true
  },
];
export default routes;
